<template>
  <div id="sales">
    <div class="">
      <ol class="breadcrumb">
        <li>
          <a href="#/dash">Dashboard</a>
        </li>
        <li>
          <a href="#/sales-resources/manage">Manage Sales Resources</a>
        </li>
        <li class="active">{{ sales.name }}</li>
      </ol>
    </div>
    <div class="content login" v-loading="loading">
      <div class="cell">
        <div class="container">
          <div class="row mt20">
            <div class="col-xs-12 col-sm-8 col-sm-offset-2 mb20">
              <p class="sub-title text-center">{{ sales.name }}</p>
            </div>
            <div class="col-xs-12 col-sm-10 col-sm-offset-1 mb20 mt20">
              <div class="row">
                <div class="col-sm-6">
                  <div class="col-sm-12 font16 lh1 mb20">
                    <span class="iconfont2 icon-g7 font36 text-middle"></span>
                    <span class="text-middle">ADD FILE</span>
                  </div>

                  <el-form
                    :model="file"
                    ref="file"
                    status-icon
                    :rules="rules"
                    validate-on-rule-change
                  >
                    <div class="col-sm-12">
                      <el-form-item
                        class="white"
                        prop="name"
                      >
                        <el-input
                          placeholder="File name"
                          v-model="file.name"
                          size="big"
                        ></el-input>
                      </el-form-item>
                    </div>
                    <div class="col-sm-12">
                      <el-form-item
                        class="white"
                        prop="url"
                      >
                        <el-input
                          placeholder="File URL"
                          v-model="file.url"
                          size="big"
                        ></el-input>
                      </el-form-item>
                    </div>
                    <div class="col-sm-12">
                      <el-form-item
                        class="white"
                        prop="file_name"
                      >
                        <el-input
                          type="file"
                          id="sales_file"
                          v-model="file.file_name"
                        ></el-input>
                      </el-form-item>
                    </div>
                    <div class="col-sm-12 text-center">
                      <button type="button" class="ebutton" @click="add_file">
                        Confirm
                      </button>
                    </div>
                  </el-form>
                </div>
                <div
                  class="col-sm-6 scroll-wrapper infinite-list-wrapper"
                  style="overflow: auto !important"
                >
                  <table class="table mb0 table-hover">
                    <tr>
                      <th class="w15">Index</th>
                      <th class>Name</th>
                      <th class="text-center w40"></th>
                    </tr>
                    <!-- loop start -->
                    <tbody>
                      <tr v-for="(i, index) in sales.files" :key="index">
                        <td class="w15">
                          <input :value="index" type="number" @change="sortSalesFiles(index, parseInt($event.target.value))"/>
                        </td>
                        <td>
                          <input v-model="i.name" type="text" @change="update_sales()"/>
                        </td>
                        <td class="text-right h40">
                          <el-tooltip
                            class="item"
                            effect="dark"
                            content="Delete"
                            placement="top"
                          >
                            <a class="black mr20" @click="delete_file(i)">
                              <span class="iconfont3 icon-delete font18"></span>
                            </a>
                          </el-tooltip>
                          <el-tooltip
                            class="item"
                            effect="dark"
                            content="View"
                            placement="top"
                          >
                            <a
                              class="black"
                              target="_blank"
                              :href="(typeof i.file_name != 'undefined' && i.file_name != '') ? $store.state.serverURL + '/' + i.file_name : i.url"
                            >
                              <span class="iconfont3 icon-view font18"></span>
                            </a>
                          </el-tooltip>
                        </td>
                      </tr>
                    </tbody>

                    <!-- loop end -->
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
 input {
  width: 100%;
  border-radius:0px;
  border: 1px solid #DCDFE6;
  padding: 4px 8px;
 }
</style>
<script>
import axios from "axios";
export default {
  name: "sales",
  data() {
    var required = (rule, value, callback) => {
      if (typeof value == "undefined" || value == null || value == "") {
        callback(new Error("Required"));
      } else {
        callback();
      }
    };
    var unique = (rule, value, callback) => {
      if (this.sales.files.filter(file => value == file.name).length > 0) {
        callback(new Error("File name needs to be unique"));
      } else {
        callback();
      }
    };
    var requiredIf = (rule, value, callback) => {
      var filledValues = [this.file.url, this.file.file_name].map((value) => String(value || '').trim()).filter(Boolean).length;
      if (filledValues == 0) {
        callback(new Error("File URL or File is Required"));
      } else if (filledValues == 2) {
        callback(new Error("Only File URL or File can be entered"));
      }
      else {
        callback();
      }
    };
    return {
      loading: false,
      file: {
        name: "",
        file_name: "",
        url:""
      },
      sales: {},
      rules: {
        name : [{validator: required}, {validator: unique}],
        url: [{ validator: requiredIf }],
        file_name: [{ validator: requiredIf }],
      },
    };
  },
  watch: {
    editTech: {
      handler(newVal) {
        this.sales = newVal;
        this.sales.files = newVal.files || [];
      },
      immediate: true,
    },
  },
  props: {
    editTech: Object,
  },
  methods: {
    sortSalesFiles(oldVal, newVal) {
      var maxIndex = this.sales.files.length - 1;
      
      if (newVal > maxIndex) {
        alert('Value is to big');
        return;
      } else if (newVal < 0) {
        alert('Value is to low');
        return;
      }

      var item1 = this.sales.files[newVal];
      var item2 = this.sales.files[oldVal];

      this.$set(this.sales.files, oldVal, item1);
      this.$set(this.sales.files, newVal, item2);
      this.update_sales();
    },
    update_sales() {
      axios
        .put("/support/sales/edit/" + this.sales._id, {
          sales: {
            files: this.sales.files,
          },
        })
        .then(async (res) => {
          if (res.data.ok == 1) {
            this.$message({
              type: "success",
              message: "Updated!",
            });
          } else {
            this.$message({
              type: "error",
              message: "Update Failed!",
            });
          }
        })
        .catch((error) => {
          alert(error);
      });
    },
    add_file() {
      this.$refs.file.validate((valid) => {
        if (valid) {
          this.loading = true;
          let formData = new FormData();
          var file = document.getElementById("sales_file").files[0];
          if (typeof file != "undefined") {
            formData.append("file", file);
          }
          formData.append("name", this.file.name);
          formData.append("url", this.file.url);
          axios
            .put("/support/sales/add_file/" + this.sales._id, formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then(async (res) => {
              if (res.data.ok == 1) {
                this.$message({
                  type: "success",
                  message: "Added!",
                });
                this.sales.files.push(res.data.item);
                this.$refs.file.resetFields();
                this.loading = false;
              } else {
                this.$message({
                  type: "error",
                  message: "Adding Failed!",
                });
                this.loading = false;
              }
            })
            .catch((error) => {
              alert(error);
              this.loading = false;
            });
        }
      });
    },
    delete_file(file) {
      axios;
      const h = this.$createElement;
      this.$msgbox({
        title: "DELETE FILE",
        message: h("p", null, [
          h("span", null, "Are you sure you want to delete "),
          h("span", { style: "color: red" }, file.name + "?"),
        ]),
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            this.loading = true;
            axios
              .put("/support/sales/remove_file/" + this.sales._id, file)
              .then(async (res) => {
                if (res.data.ok == 1) {
                  this.$message({
                    type: "success",
                    message: "Deleted!",
                  });
                  this.sales.files.splice(
                    this.sales.files.findIndex(
                      (f) => f.name == file.name
                    ),
                    1
                  );
                  this.loading = false;
                  done();
                } else {
                  this.$message({
                    type: "error",
                    message: "Delete Failed!",
                  });
                  this.loading = false;
                }
              })
              .catch((error) => {
                window.console.log(error);
                this.loading = false;
              });
          } else {
            done();
          }
        },
      });
    },
  },
};
</script>